<div class="editions-table-wrapper">

  <div class="editions-table-header">
    <div>
      <h6>
        <i class="pi pi-history"></i>
        Historial de ediciones
      </h6>

      <span>
        Registro de modificaciones realizadas sobre el usuario
      </span>
    </div>
  </div>

  <p-table [value]="editions!" [paginator]="true" [rows]="5" [rowsPerPageOptions]="[5, 10, 20]"
    [showCurrentPageReport]="true" paginatorDropdownAppendTo="body"
    currentPageReportTemplate="{first} - {last} de {totalRecords}" [totalRecords]="totalRecords"
    [tableStyle]="{ width: '100%' }" [styleClass]="'p-datatable-sm editions-history-table'">

    <ng-template pTemplate="header">
      <tr>
        <th>
          <div class="edition-th">
            <i class="pi pi-calendar"></i>
            <span>Fecha</span>
          </div>
        </th>

        <th>
          <div class="edition-th">
            <span>Descripción</span>
          </div>
        </th>

        <th *ngIf="realizo_lod">
          <div class="edition-th">
            <span>LOD1</span>
          </div>
        </th>
        <th >
          <div class="edition-th">
            <span>Usuario Editado</span>
          </div>
        </th>

        <th *ngIf="realizo_lod">
          <div class="edition-th">
            <span>LoB</span>
          </div>
        </th>

        <th>
          <div class="edition-th">
            <span>Usuario</span>
          </div>
        </th>


      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-edition>

      <!-- FILA PRINCIPAL -->
      <tr class="edition-row">

        <!-- FECHA -->
        <td>
          <div class="edition-date">
            <i class="pi pi-calendar"></i>

            <div>
              <span>
                {{ edition.fecha | date : 'dd/MM/yyyy' }}
              </span>

              <small>
                {{ edition.fecha | date : 'HH:mm' }}
              </small>
            </div>
          </div>
        </td>

        <!-- DESCRIPCIÓN -->
        <td>
          <span class="edition-description" [pTooltip]="edition.descripcion" tooltipPosition="top">
            {{ edition.descripcion }}
          </span>
        </td>

        <!-- LOD -->
        <td *ngIf="realizo_lod">
          <span class="edition-badge">
            {{ edition.editions_form?.id_visible || '-' }}
          </span>
        </td>

        <td *ngIf="realizo_lod">
          <span class="lob-value">
            {{ edition.editions_form?.lob?.name || '-' }}
          </span>
        </td>
        <td>
          <span class="lob-value">
            {{ edition?.editions_usuario?.full_name || '-' }}
          </span>
        </td>
        <td>
          <div class="edition-user">
            <div class="edition-user-icon">
              <i class="pi pi-user"></i>
            </div>

            <span>
              {{ edition.usuario
              ? returnData(edition.usuario)
              : 'Sin información' }}
            </span>
          </div>
        </td>

        <!-- ACCIONES -->
        <td class="edition-actions">

          <!-- <button
        *ngIf="properties && edition.old_register"
        type="button"
        class="edition-action-button"
        pTooltip="Ver registro anterior"
        tooltipPosition="top"
        (click)="div.classList.toggle('show-container')"
      >
        <i class="pi pi-eye"></i>
      </button> -->

          <span *ngIf="!properties || !edition.old_register" class="no-action">
            -
          </span>

        </td>

      </tr>


      <!-- REGISTRO ANTERIOR -->
      <tr *ngIf="properties && edition.old_register" class="old-register-row">

        <td [attr.colspan]="realizo_lod ? 6 : 4">

          <div class="hide-container" #div>

            <div *ngIf="edition.parseObject" class="old-register-content">

              <div class="old-register-title">
                <i class="pi pi-clock"></i>
                Registro anterior
              </div>

              <div class="old-register-field" *ngFor="let item of properties">

                <span>
                  {{ item.label }}
                </span>

                <div [innerHtml]="item.value(edition.parseObject)"></div>

              </div>

            </div>

          </div>

        </td>

      </tr>

    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="realizo_lod ? 6 : 4">

          <div class="editions-empty">
            <i class="pi pi-history"></i>

            <span>
              No hay registros de ediciones para mostrar.
            </span>
          </div>

        </td>
      </tr>
    </ng-template>

  </p-table>

</div>
